<template>
<div class='logo'>
    <router-link to="/">
    <img src="/static/favicon_web.png"/>
    <div >
            <div class="title1">{{t('__logo')}}</div>
            <div class="title2">{{t('__subtitle')}}</div>
    </div>
    </router-link>
</div>

</template>


<script>
import { ref } from "vue"
import { useI18n } from "vue-i18n"

export default {
    setup () {
        let title1_font_size=ref()
        let title2_display=ref()
        let title1_top=ref()

        let {t, locale} = useI18n(
            {
                messages: {
                    'en': {
                        '__logo': "Python Atomic"
                        ,"__subtitle": "Shared atomicity with multithreads or multiple processes, coroutines"
                    },
                    'zh_CN': {
                         "__logo": "Python共享类型"
                        ,"__subtitle": "多线程，多进程，多协程可用共享原子性"
                    },
                    'zh_HK': {
                         "__logo": "Python共享類型"
                        ,"__subtitle": "多線程，多進程，多協程可用共享原子性"
                    },
                    'zh_TW': {
                         "__logo": "Python共享類型"
                        ,"__subtitle": "多線程，多進程，多協程可用共享原子性"
                    }
                }
            }
        )
        return {t, locale, 
            title1_font_size, 
            title1_top, 
            title2_display}
    },
    
    props:{
        color:{
            type:[String],
            required:true,
            //default:"#FFF"
        },
    },

    mounted() {
        let width=window.screen.width;
        if (this.$is_wechat && width<=1080){
                this.title1_font_size='3.9vw'
                this.title2_display='none'
                this.title1_top="0.1vw"
        }
        else {
            this.title1_font_size='4.2vw'
            this.title2_display='block'
            this.title1_top="0"
        }
    }
}
</script>

<style scoped>
.logo {
    position: relative;
}
img {
    position: absolute;
    left: 0;
}
.title1 {
    position: absolute;
    color: v-bind(color);
}
.title2 {
    position: absolute;
    bottom: 0;
    color: v-bind(color);
    display: v-bind(title2_display);
}

@media screen and (max-width: 768px){
    .logo {
        /*width: 1.56rem;*/
        width: 38.542vw;
        height: 7.165vw;
    }
    img {
        width: 7.165vw;
        height: 7.165vw;
        top: 0;

    }
    .title1 {
        font-size: v-bind("title1_font_size");
        /*font-size: 0.17rem;*/
        top: v-bind("title1_top");
        left: 7.659vw;
    }
    .title2 {
        font-size: 1.66vw;
        /*font-size: 0.0672rem;*/
        left: 7.659vw;
        bottom: -0.741vw;
        top: v-bind("locale==='en'? '4.5vw':'5.7vw'");
        line-height: 90%;
    }
}
@media screen and (max-width: 1080px) and (min-width: 768px){
    .logo {
        width: 38.542vw;
        height: 8vw;
    }
    img {
        width: 7.5vw;
        height: 7.5vw;
        bottom: -0.16vw;
    }
    .title1 {
        font-size: 4.0vw;
        left: 8vw;
    }
    .title2 {
        font-size: 1.55vw;
        left: 8vw;
        top: v-bind("locale==='en'? '4.4vw':'5.5vw'");
    }
}

@media (min-width: 1080px) {
    .logo {
        width: 2.2rem;
        /*width: 4.5630vw;*/
        height: 0.4rem;
    }
    img {
        width: 0.4rem;
        /*width: 4.185vw;*/
        height: 0.4rem;
        top: 0;
    }
    .title1 {
        /* font-size: 1vw; */
        font-size: 0.183rem;
        top: -0.01rem;
        left: 0.5rem;
    }
    .title2 {
        font-size: 0.0915rem;
        left: 0.5rem;
        top: v-bind("locale==='en'? '0.197rem':'0.245rem'");
    }
}
</style>